import Vue from "vue";
import Vuex from "vuex";
import { vueObj } from "./main";
import { userInfo, api_ReqItemList, boxList } from "@/api";
import { modules } from "@/store/modules";
import sell_sound from "@/assets/audio/coin_pickup_01.wav";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    pageHidden: false, // 页面是否没有激活
    //官网相关
    //滚动
    se_scroll: false,
    //滚动top
    top_scroll: false,

    //开盲盒active
    box_active: false,
    //遮罩
    official_loading: false,
    // 登录弹窗
    logpopShow: false,

    //刮刮乐数量
    scrape: 0,

    //弹框
    messageData: {
      show: false,
      text: "",
      left_btn: "",
      right_btn: "",
      path: "",
    },
    sellSound: new Audio(sell_sound),
    notice_list: [],
    config: configs,
    user: JSON.parse(sessionStorage.getItem("user")) || {
      balance: 0,
      recycles: 0,
      coin1Available: 0,
      redPacketBalance: 0,
      freeCase: false,
      tradeUrl: "",
    },
    tradeOfferBox: {
      show: false,
      list: [],
    },
    loginModal: {
      flag: false,
      active: "sign_in",
      from: {
        email: "",
        emailErorr: "",
        code: "",
        code_error: "",
        password: "",
        passwordErorr: "",
        password2: "",
        password2Erorr: "",
        agreeErorr: "",
        agree: false,
        inviteD: "",
      },
      Interval: null,
      setWindow: null,
      isLoginSuccess: null,
    },
    systemAuthSwitch: {
      System_Register: "0",
      System_Login: "0",
    },
    PayModal: {
      flag: false,
      idflag: false,
    },
    RedPacketModal: {
      flag: false,
      idflag: false,
    },
    boxList: [],
    mpCaseList: {
      mpcCaseSettings: {},
      battleCaseList: [],
      caseData: []
    },   
    banner_list: [],
    GobalInfo: {
      GroupLink: "", //群链接
      ServiceLink: "", //客服链接
      caseCount: 0, //客服链接
      userCount: 0, //客服链接
      luckyItemCount: 0, //客服链接
      battleCount: 0, //客服链接
    },
    isMute: false,
    // 首屏加载
    spinShow: false,
    acl: [],
    featureAccess: {},
    currentCate: "",
  },
  getters: {},
  mutations: {
    //官网相关

    //遮罩
    set_official_loading(store, v) {
      store.official_loading = v;
    },

    //刮刮乐数量
    set_scrape(store, v) {
      store.scrape = v;
    },

    //弹框
    set_messageData(store, v) {
      store.messageData = v;
    },

    // 登录弹窗
    set_logpopShow(store, value) {
      store.logpopShow = value;
    },
    //箱子列表
    getboxList(state) {
      boxList()
        .then((res) => {
          if (res.data.code === 0) {
            state.boxList = res.data.data;
            state.spinShow = false;
          }
        })
        .catch((e) => {
          console.log(22222222, e);
          state.spinShow = false;
        });
    },
    setBannerList(state, banners) {
      state.banner_list = banners;
    },
    setNoticeList(state, notices) {
      state.notice_list = notices;
    },
    setSystemAuthSwitch(state, value = {}) {
      state.systemAuthSwitch = {
        System_Register: String(value.System_Register || "0"),
        System_Login: String(value.System_Login || "0"),
      };

      const isRegisterModal = state.loginModal.active === "register_mobile";
      const canShowModal = isRegisterModal
        ? state.systemAuthSwitch.System_Register === "1"
        : state.systemAuthSwitch.System_Login === "1";

      if (!canShowModal) {
        state.loginModal.flag = false;
      }
    },
    // 设置页面激活状态
    setPageHidden(state, val) {
      state.pageHidden = val;
    },
    //更新用户信息
    setInfo(state) {
      userInfo().then((res) => {
        if (res.data.code === 0) {
          res.data.data.qqFlag = res.data.data.qq ? true : false;
          res.data.data.invitationCodeFlag = res.data.data.invitation
            ? true
            : false;
          state.user = res.data.data;
          // state.user.balance = res.data.data.recycles + res.data.data.balance;
          state.user.tradeUrl = res.data.data.tradeUrl;
          sessionStorage.setItem("user", JSON.stringify(res.data.data));
          if (state.loginModal.setWindow) {
            state.loginModal.setWindow.close();
          }
          clearInterval(state.loginModal.Interval);
        } else if (res.data.code === 20001) {
          state.loginModal.active = "sign";
          state.loginModal.flag = true;
          if (state.loginModal.setWindow) {
            state.loginModal.setWindow.close();
          }
          clearInterval(state.loginModal.Interval);
        } else {
          state.user = { balance: 0, recycles: 0, freeCase: false };
          sessionStorage.removeItem("user");
          localStorage.removeItem("Invitation");
        }
      });
    },
    //获取最新取回列表
    RequestTradeOffer(state) {
      var offerids = state.tradeOfferBox.list.map((_) => {
        return _.id;
      });

      api_ReqItemList({ lstOfferid: offerids }).then((res) => {
        if (res.data.code === 0 && res.data.data) {
          state.tradeOfferBox.list = res.data.data;
        }
      });
    },
    /** 切换取回栏显示状态 */
    switch_tradeofferbox_show(state, flag) {
      if (!state.user.nickname) {
        state.tradeOfferBox.show = false;
        this.commit("setloginModal", true);
        return;
      }

      if (flag) this.commit("RequestTradeOffer");

      state.tradeOfferBox.show = flag;
    },
    //打开登录窗口
    async setloginModal(state, obj) {
      const flag = typeof obj === "object" && obj !== null ? obj.flag : obj;

      if (!flag) {
        state.loginModal.flag = false;
        return;
      }

      const isRegisterModal = state.loginModal.active === "register_mobile";
      const canShowModal = isRegisterModal
        ? state.systemAuthSwitch.System_Register === "1"
        : state.systemAuthSwitch.System_Login === "1";

      if (!canShowModal) {
        state.loginModal.flag = false;
        return;
      }

      const response = await axios.get("/promote.json");
      const promote = response.data;
      const domain = window.location.hostname.split(".").reverse()[1];
      const code = promote[domain]
        ? promote[domain]
        : sessionStorage.getItem("code");
      state.loginModal.flag = flag;
      state.loginModal.from.inviteD = code || "";
    },
    //打开充值窗口
    setPayModal(state, obj) {
      if (obj && !state.user.nickname) {
        this.commit("setloginModal", true);
        return;
      }

      /*if(obj && !state.user.idCard){
        state.PayModal.idflag = true;
        return;
      }*/

      state.PayModal.flag = obj;
    },
    //打开红包窗口
    setRedPacketModal(state, obj) {
      if (obj && !state.user.nickname) {
        this.commit("setloginModal", true);
        return;
      }
      state.RedPacketModal.flag = obj;
    },
    /** 开箱音效是否启用 切换 */
    toggle_muted(state) {
      state.isMute = !state.isMute;
      sessionStorage.site_muted = state.isMute;
    },
    load_muted(state) {
      state.isMute = sessionStorage.site_muted;
    },
    setSpinShow(state, bool = false) {
      state.spinShow = bool;
    },
    setAcl(state, obj) {
      state.acl = obj;
    },
    setFeatureAccess(state, obj) {
      state.featureAccess = obj || {};
    },
    setCurrentCate(state, payload) {
      state.currentCate = payload;
    },
  },
  actions: {},
  modules,
});
